// extracted by mini-css-extract-plugin
export default {"root":"vpIy8SJF","contentWrapper":"k6xBkKgX","contentNoPadding":"Cm5rTYyq","content":"qYNtAmTL"};